import { TeacherSalaryType } from '../../../types'
import { directionGroupApi } from '@/api'
import { ApiResult } from '@modals/RequiredEmailConfirmation/components/RequiredEmailConfirmationModal/utils/api'

export interface IUpdateTeacherSalaryPayload {
  group_id: number
  teacher_id: number
  type: TeacherSalaryType
  salary: number
  duration_minutes: number | null
  min_amount_enabled?: boolean
  min_amount?: number | null
  paid_cancel_percent?: number
  student_rates?: Record<string, number>
  effective_from?: string
  apply_to_completed?: boolean
}

export interface IUpdateTeacherSalaryForAllGroupsPayload {
  teacher_id: number
  type: TeacherSalaryType
  salary: number
  duration_minutes: number | null
  min_amount_enabled?: boolean
  min_amount?: number | null
  paid_cancel_percent?: number
  student_rates?: Record<string, number>
  effective_from?: string
  apply_to_completed?: boolean
}

export const updateTeacherSalary = async (
  data: IUpdateTeacherSalaryPayload,
): Promise<ApiResult<IUpdateTeacherSalaryPayload>> => {
  try {
    const res = await directionGroupApi.updTeacherSalary(data)

    return {
      data: res?.data?.data || res?.data || null,
      success: res?.data?.status === 'success',
      error:
        res?.data?.error || res?.data?.message || 'Ошибка сохранения зарплаты',
    }
  } catch (error) {
    console.error('Ошибка updateTeacherSalary:', error)
    return {
      data: null,
      success: false,
      error: error instanceof Error ? error.message : String(error),
    }
  }
}

export const updateTeacherSalaryForAllGroups = async (
  data: IUpdateTeacherSalaryForAllGroupsPayload,
): Promise<ApiResult<IUpdateTeacherSalaryForAllGroupsPayload>> => {
  try {
    const res = await directionGroupApi.updTeacherSalaryForAllGroups(data)

    return {
      data: res?.data?.data || res?.data || null,
      success: res?.data?.status === 'success',
      error:
        res?.data?.error ||
        res?.data?.message ||
        'Ошибка сохранения зарплаты для всех групп',
    }
  } catch (error) {
    console.error('Ошибка updateTeacherSalaryForAllGroups:', error)
    return {
      data: null,
      success: false,
      error: error instanceof Error ? error.message : String(error),
    }
  }
}
